/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InlineObject15
 */
export interface InlineObject15 {
    /**
     * 
     * @type {number}
     * @memberof InlineObject15
     */
    aktid: number;
    /**
     * 
     * @type {string}
     * @memberof InlineObject15
     */
    date: string;
}

export function InlineObject15FromJSON(json: any): InlineObject15 {
    return InlineObject15FromJSONTyped(json, false);
}

export function InlineObject15FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineObject15 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'aktid': json['aktid'],
        'date': json['date'],
    };
}

export function InlineObject15ToJSON(value?: InlineObject15 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'aktid': value.aktid,
        'date': value.date,
    };
}


